import { Banner } from '@stenajs-webui/elements';
import { Information } from '../../common/texts';

export function GoodsDescriptionsEnsHintBanner() {
  return <Banner variant={'info'} text={Information.GoodsDescriptionEnsHint} />;
}
